/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { getAnswersById, getChoicesByValue } from './questionaire';

const propTypes = {
    questions: PropTypes.array,
    answers: PropTypes.array,
    onAnswerEdit: PropTypes.func,
};

const defaultProps = {};

export default class QuestionsSummary extends React.Component {
    render() {
        const questions = this.props.questions.slice(0).reverse();
        const answers = getAnswersById(this.props.answers);
        const answeredQuestions = [];
        questions.forEach((q) => {
            const answer = answers[q.id];
            if (answer && q.choices) {
                answeredQuestions.push(q);
            }
        });

        return (
            <div className="rec-questionnaire-summary">
                {answeredQuestions.map((q, index) => {
                    let answer = answers[q.id];
                    const choices = getChoicesByValue(q.choices);
                    answer = choices[answer.value].description;
                    const counter = answeredQuestions.length - index;
                    return (
                        <div key={`${q.id}`} className={'rec-questionnaire-summary-item'}>
                            <div className={'rec-questionnaire-summary-question'}>
                                Q{' '}
                                {counter.toLocaleString('en-US', {
                                    minimumIntegerDigits: 2,
                                    useGrouping: false,
                                })}{' '}
                                / {q.description}
                            </div>
                            <div className={'rec-questionnaire-summary-answer'}>
                                <button
                                    className={'rec-button-link'}
                                    onClick={this.props.onAnswerEdit.bind(
                                        this,
                                        answer,
                                        q
                                    )}
                                >
                                    {answer}
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

QuestionsSummary.displayName = 'QuestionsSummary';
QuestionsSummary.propTypes = propTypes;
QuestionsSummary.defaultProps = defaultProps;
